import React from 'react';
import { connect } from 'react-redux';
import { fetchMembershipTypes, selectMembershipType, fetchMembershipPackages } from '../../../../../../Redux/Actions/EndUser/MembershipAction';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import './MembershipType.scss';
class Membership extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: {
                membershipTypeID: 0,
                description: ''
              }
        };

    }
    componentDidMount() {
        this.props.fetchMembershipTypes();
        var value = this.state.value;
        if (this.props.membership.selectedMembershipType !== null) {
            this.setState({
                value: this.props.membership.selectedMembershipType
            });
            value = this.props.membership.selectedMembershipType;
        }
        this.selectedMembershipType(value);
    }

    handleChange = (event) => {
        this.selectedMembershipType(event.target.value);
    }

    selectedMembershipType = (value) => {
        this.props.selectMembershipType(value);
        if (value !== null) {
            this.setState({ value: value })
            this.props.updateSelectedMembership();
            this.props.fetchMembershipPackages(value.membershipTypeID);
        }
    }

    render() {
        return (
            <div className="membershipForm borderBottom">
                <h1 className="pt-3 pb-3">Member Information</h1>
                <h3>Fill out the following fields to claim your membership!</h3>
                <form className="">
                    <label>What type of membership do you want?</label>
                    <DropDownList data={this.props.membership.membershipTypes?.filter(type => type.description.toUpperCase() != 'TSCRA_VERIFY')}
                        textField="description"
                        dataItemKey="membershipTypeID"
                        onChange={this.handleChange}
                        value={this.state.value}
                        allowCustom={false}
                        filterable={false}
                        clearButton={false}
                        width={300}
                        required={true}
                    />
                </form>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { membership: state.membership }
}

export default connect(mapStateToProps, { fetchMembershipTypes, selectMembershipType, fetchMembershipPackages })(Membership);

